module.exports = __webpack_public_path__ + "assets/vehicle_map_hybrid.22271ea6.svg";